import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import type { ILeadsSearchDescriptionDto } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";
import type { ProfilesResponseDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";

import EmployeeProfilesFilterContainer from "../../components/filters/EmployeePersonasFilter/EmployeeProfilesFilterContainer";
import EmployeeProfilesFilterResult from "../../components/filters/EmployeePersonasFilter/EmployeeProfilesFilterResult";
import { contactsFilterCategoryMap } from "../../types/contactsFilterCategory";

import EmployeePersonasFilterModel from "./EmployeePersonasFilterModel";

const createEmployeePersonasFilter = (
    profilesResponse: ProfilesResponseDto,
    employeeProfile: Partial<ILeadsSearchDescriptionDto["employeeProfile"]> = {},
): SearchFilterInstance => {
    return {
        key: "employeeProfiles",
        trackingName: "Employee Profiles",
        apiCategory: "contactsFilters",
        category: contactsFilterCategoryMap.contacts,
        title: { key: "si.lead_gen_filters.category.employee_profiles" },
        tooltipText: { key: "si.lead_gen_filters.category.employee_profiles.tooltip" },
        filter: new EmployeePersonasFilterModel(profilesResponse.profiles, employeeProfile),
        filterResultView: EmployeeProfilesFilterResult,
        filterView: EmployeeProfilesFilterContainer,
    };
};

export default createEmployeePersonasFilter;
